export { useScrollListener as useScrollListener };
export { _ as _ };
import * as vue_composition_api from '@vue/composition-api';

const useScrollListener = () => {
  const scrolledTo = vue_composition_api.ref(null);
  const scrollHandler = () => {
    scrolledTo.value = window.scrollY;
  };
  window.addEventListener('scroll', scrollHandler);
  vue_composition_api.onUnmounted(() => {
    window.removeEventListener('scroll', scrollHandler);
  });
  return {
    scrolledTo
  };
};
const _ = null;

export default { useScrollListener };
